import {useState, useRef, useEffect} from 'react';
// ** Reactstrap Imports
import { Row, Col, Card, CardBody, Form, Label, Input, Button } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom'
import { BiLeftArrowAlt } from 'react-icons/bi';
import axios from 'axios';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import { MdOutlineAdd, MdRemove } from 'react-icons/md';
import ReactQuill from "react-quill";
import EditorToolbar, { modules, formats } from "../../utils/EditorToolbar";
import 'react-quill/dist/quill.snow.css';
import useAuth from '../../hooks/useAuth';

const EditCommunityPortalInfo = () => {
  const { auth } = useAuth();

  const navigate = useNavigate();
  const {id} = useParams();
  const [portalInfo, setPortalInfo] = useState({})

  const ondescription = (value) => {
    setPortalInfo((prev) => {
      return {
        ...prev,
        communityDesc:value
      }
    })
    // setPortalInfo({ ...portalInfo,
    //     communityDesc:value
    // });
  } 


    // ** States

    const handleChange = (event) => {
        const { value, name } = event.target
        setPortalInfo(prevValue => {
            return({
                ...prevValue,
                [name]: value
            })
        });
    }

    const handleUpdateClick = async (event) => {
        event.preventDefault();

        let communityTagLine =  portalInfo.communityTagLine;
        let communityDesc = portalInfo.communityDesc;

        const formData = new FormData();
        formData.append('communityTagLine', communityTagLine);
        formData.append('communityDesc', communityDesc);


        try {
            const res = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/community-portal/update/${id}`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'Bearer ' + auth.accessToken
                }
            })
            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
            navigate('/community/web-portal/view')


        } catch (error) {
            console.error(error)
          error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
            
        }
    }


    const handleReset = async (event) => {
      event.preventDefault();
      navigate('/community/web-portal/view')
    }

    const getData = async () => {
      try {
        await axios.get(`${process.env.REACT_APP_API_BASE_URL}/community-portal/find/${id}`, {
            headers: {
                'Authorization': 'Bearer ' + auth.accessToken
            }
        }).then(res => {
          res && setPortalInfo(res.data);     

        })
        
    } catch (error) {
      error.response.data.message ? toast.error(error.response.data.message, {
        className: "error-toast",
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000
        }) :  toast.error(error.response.data.error, {
          className: "error-toast",
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000
      })
    }
  }

    useEffect(() => {
      
      
    getData();
  },[id])
 
  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Edit CommunityPortalInfo</h5>
      </Row> 
      <Row sm='12'>
        <Card>
            <CardBody>
            
          <Col sm='12' className='mb-2'>
          <Form>
            
          <div className='mb-1'>
              <Label className='form-label' for='communityTagLine'>
               Tagline <span className='text-danger'>*</span>
              </Label>
              <Input
                id='communityTagLine'
                type='text'
                className='me-1'
                name='communityTagLine'
                minLength={20}
                maxLength={90}
                required={true}
                value={portalInfo && portalInfo.communityTagLine || ''}
                onChange={handleChange}
                
              />

            </div>

            <div className='mb-1'>
              <Label className='form-label' for='communityDesc'>
                Service Description <span className='text-danger'>*</span>
              </Label>
              <EditorToolbar toolbarId={'t1'} />
              <ReactQuill 
              id='communityDesc'
              theme="snow"                    
              value={portalInfo.communityDesc || ''}
              onChange={ondescription}                 
              placeholder={"Write something awesome..."}
              modules={modules('t1')}
              formats={formats}
              />


            </div>

           
            <Row className='pt-2'>
              <Col>
              <div className='mb-1'>
                <Button
                  block
                  color="success"
                  type='submit'
                  onClick={handleUpdateClick}
                >
                  Update
                </Button>
              </div>
          
              </Col>
              <Col>
                <div className='mb-1'>
                  <Button
                    block
                    color="warning"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </div>         
              </Col>
            </Row>
          </Form>
            
          </Col>
          </CardBody>
        </Card>
          
      </Row>
    
      <Row sm="12" className="mt-4 text-center">
          <Link to={"/community/web-portal/view"} className="go_back" >
            <BiLeftArrowAlt size={30} />  Go to community portal list
          </Link>
      </Row> 
    </div>
  );
};

export default EditCommunityPortalInfo;
